import { Device } from 'modules/Device/Device'
import { Org } from 'modules/Org/Org'
import { Tank } from 'modules/Tank/Tank'
import { TankLevelNode } from 'modules/TankLevelNode/TankLevelNode'
import { Tenant } from 'modules/Tenant/Tenant'
import { Model } from 'pinia-orm'
import { Attr, Uid, BelongsTo, HasMany } from 'pinia-orm/dist/decorators'

export class TankLevelCalibration extends Model {
  static override entity = 'tank_level_calibrations'

  // Fields
  @Uid() declare id: string

  @Attr(null) declare sensor_min_adc: number | null
  @Attr(null) declare sensor_max_adc: number | null
  @Attr(null) declare sensor_min_ma: number | null
  @Attr(null) declare sensor_max_ma: number | null
  @Attr(null) declare max_height_mm: string | null
  @Attr(null) declare min_height_mm: string | null
  @Attr(null) declare probe_density: number
  @Attr(null) declare fluid_density: string
  @Attr(null) declare height_offset_mm: string
  @Attr(null) declare volume_offset_liters: string
  @Attr(null) declare rounding_l: number | null
  @Attr(null) declare sensor_type: string | null
  @Attr(null) declare calculation_version: number | null

  // Relationships
  @Attr(null) declare device_id: string | null
  @BelongsTo(() => Device, 'device_id') declare device: Device | null

  @Attr(null) declare tank_id: string | null
  @BelongsTo(() => Tank, 'tank_id') declare tank: Tank | null

  @HasMany(() => TankLevelNode, 'tank_level_calibration_id') declare tank_level_nodes: TankLevelNode[]

  @Attr(null) declare tenant_id: string
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null

  @Attr(null) declare org_id: string
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
